import { createI18n } from 'vue-i18n';
import Store from '@/store/index';
import Api from '@/store/api';


const locale = document.querySelector('html').getAttribute('lang');
const i18n = createI18n({
  legacy: true,
  locale,
  messages: {},
  silentTranslationWarn: true,
  missingWarn: false,
  fallbackWarn: false,
  warnHtmlMessage: false,
});

// The messages come from the Rails backend and are written for Rails: placeholders are Ruby-style
// (`%{count}`), and `@` and `|` are plain characters (mail addresses, "a | b"). vue-i18n 8 accepted
// `%{count}` as an alias of `{count}`; vue-i18n 9+ interpolates only `{count}` (leaving the `%` on
// screen), reads `@` as the start of a linked message (a compile error for `sales@metroengines.jp`)
// and `|` as a plural separator (dropping everything before it), so rewrite the messages once, as
// they are loaded. No message uses vue-i18n's linked syntax and nothing calls `$tc`.
export function toVueI18nMessage(messages) {
  if (typeof messages === 'string') {
    return messages.replace(/%\{(\w+)\}/g, '{$1}').replace(/[@|]/g, (char) => `{'${char}'}`);
  }
  if (Array.isArray(messages)) return messages.map(toVueI18nMessage);
  if (messages && typeof messages === 'object') {
    return Object.fromEntries(Object.entries(messages).map(([key, value]) => [key, toVueI18nMessage(value)]));
  }
  return messages;
}

Api.get('/api/frontend/locales.json').then((res) => {
  if (res.data) {
    i18n.global.setLocaleMessage(locale, toVueI18nMessage(res.data));
    Store.dispatch('loadedLocales');
  } else {
    console.log(res);
  }
});

export default i18n;
